import scienceLogo from "../assets/images/science-nav-logo.png";
import scienceAdd from "../assets/images/science-add-btn.png";
import scienceGood from "../assets/images/science-good-icon.png";
import scienceLook from "../assets/images/science-look-icon.png";
import successImg from "../assets/images/science-success.png";

const SCIENCE_CONFIG = {
  assets: {
    logo: scienceLogo,
    add: scienceAdd,
    good: scienceGood,
    look: scienceLook,
    success: successImg,
  },
  style: {
    "primary-color": "#3379c4",
    "primary2-color": "#144e8c",
    "primary3-color": "#144e8c",
    "evaluate-border": "#3379c4",
    "evaluate-active": "rgba(51, 121, 196, 0.05)",
    // +1相关样式开始
    "evaluate-bg": "unset",
    "evaluate-num": "#144e8c",
    "text-fill-color": "unset",
    // +1相关样式结束
    "btn-color": "#3379c4",
  },
  text: {
    haobtn: "贡献显著",
    badbtn: "理论局限",
  },
  var: {
    appid: "wx04847d842d36ed05",
    hideLoginEntry: true,
    hideMobileLoginEntry: false,
    beian: "京ICP备2021005318号-1",
  },
};

export default SCIENCE_CONFIG;
